<template>
  <div>
    <button @click='methodOne' class="btn-1">
      <slot></slot>
    </button>
  </div>
</template>

<script>
export default {
  data(){
    return{
      obj:{
        time:0,
        message:'message'
      }
    }
  },
  methods:{
    methodOne : function(){
      return this.$emit('methodOne',this.obj);
    }
  }
}
</script>

<style scoped>
.btn-1{
  background-color: bisque;
  color: red;
  border :black;
  border-radius: 5pt;
}


</style>